module.exports = require('./lib/no-important.js'); // eslint-disable-line import/no-unresolved
